<template>
<div class="chapter">
<div class="inner_page">
<p class="ded1"><a id="page_3"></a><a id="page_4"></a><em class="italic">This book is dedicated to Patricia,</em></p>
<p class="ded2"><em class="italic">who introduced us.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?88874aa6